const PREFIX = 'nav_back:'

// 从子页回到列表时，不覆盖列表页已记录的“真正入口”
const SKIP_BACK_OVERWRITE = [
  { from: 'product', to: 'products' },
  { from: 'packageInfo', to: 'package' },
  { from: 'activityCategory', to: 'activities' }
]

function shouldSkipBackOverwrite(from, to) {
  if (!from || !from.name || !to || !to.name) {
    return true
  }
  // 同名路由仅改 query（切分类等）不算“进入新页面”，不要覆盖来源
  if (from.name === to.name) {
    return true
  }
  return SKIP_BACK_OVERWRITE.some(
    item => item.from === from.name && item.to === to.name
  )
}

export function saveRouteBack(to, from) {
  if (!from || !from.name || from.fullPath === to.fullPath) {
    return
  }
  if (shouldSkipBackOverwrite(from, to)) {
    return
  }
  const key = PREFIX + (to.name || to.path)
  sessionStorage.setItem(
    key,
    JSON.stringify({
      name: from.name,
      query: from.query || {},
      params: from.params || {}
    })
  )
}

export function getRouteBack(route) {
  const key = PREFIX + (route.name || route.path)
  const raw = sessionStorage.getItem(key)
  if (!raw) {
    return null
  }
  try {
    const location = JSON.parse(raw)
    // 来源必须是不同页面，否则视为无效（避免卡在本页）
    if (!location.name || location.name === route.name) {
      return null
    }
    // 双向环：A↔B 互为来源时作废，避免两个页面来回横跳
    const peerRaw = sessionStorage.getItem(PREFIX + location.name)
    if (peerRaw) {
      try {
        const peer = JSON.parse(peerRaw)
        if (peer && peer.name === route.name) {
          sessionStorage.removeItem(key)
          return null
        }
      } catch (e) {
        // ignore
      }
    }
    return location
  } catch (e) {
    // ignore invalid cache
  }
  return null
}

export function isDifferentPage(a, b) {
  return !!(a && b && a.name && b.name && a.name !== b.name)
}



// WEBPACK FOOTER //
// ./src/util/routeBack.js